/* 
 * Export component file to be used on project
*/

import { DateInput } from './DateInput.js';
export default DateInput;
